'use client';

import { Spinner } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { useEffect, useEffectEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';
import type { FormValues } from '../../common';
import type { useReKyc } from '../../hooks/useReKyc';

type UpdatingAddressStepProps = {
  updateMutation: ReturnType<typeof useReKyc>['updateMutation'];
};

function UpdatingAddressStep({ updateMutation }: UpdatingAddressStepProps) {
  const t = useTranslations('my_account.rekyc');

  const formState = useMultistepForm();
  const { getValues } = useFormContext<FormValues>();
  const { mutateAsync } = updateMutation;
  const goToNextStep = useEffectEvent(formState.goToNextStep);
  const goToPreviousStep = useEffectEvent(formState.goToPreviousStep);

  useEffect(() => {
    const addressData = getValues('edit-address.address');
    mutateAsync({
      addressData: {
        streetNr: addressData.streetNr,
        streetName: addressData.streetName,
        // addressLine1: addressData.addressLine1,
        extraAddressField: addressData.addressLine2,
        city: addressData.addressLevel2,
        country: 'GB',
        postCode: addressData.postalCode,
      },
    }).then(
      () => {
        goToNextStep();
      },
      () => {
        goToPreviousStep();
      }
    );
  }, [getValues, mutateAsync]);

  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-5 py-6">
      <Spinner className="animate-spin" />
      <p className="paragraph text-foreground" data-testid="updating-message">
        {t('updating_step.message')}
      </p>
    </div>
  );
}

export { UpdatingAddressStep, type UpdatingAddressStepProps };
